import { makeAutoObservable, observable } from 'mobx'
import { ComboItemsStore } from 'page/catalog/store/ComboItemsStore'
import { mx } from 'store/base/mx'
import { CLOSE } from 'store/base/mx/MxRef'
import { Item } from 'type/Item'
import { updateSearchParams } from 'util/history'

export class ItemPreviewStore {
  readonly item: Item
  readonly scroll: boolean
  combo: Item | null = null
  private _current = 0
  readonly items: ComboItemsStore

  constructor(item: Item, scroll?: boolean) {
    this.item = item
    this.scroll = !!scroll
    this.items = new ComboItemsStore(item)
    updateSearchParams({ item_id: item.item_id })
    makeAutoObservable(this, { item: observable.ref, combo: observable.ref })
  }

  get images(): string[] {
    return this.item.images
  }

  get len(): number {
    return this.images.length
  }

  get current(): number {
    return this._current
  }

  set current(value: number) {
    value = Math.max(0, Math.min(this.len - 1, value))
    this._current = value
  }

  toggleCombo(item: Item) {
    this.combo = this.combo === item ? null : item
  }

  [CLOSE]() {
    updateSearchParams({ item_id: undefined })
  }
}

export const itemPreview = mx.ref<ItemPreviewStore>()
